// extracted by mini-css-extract-plugin
module.exports = {"pulsingLogo":"spinner_pulsingLogo__2j-5l","heartbeat":"spinner_heartbeat__4P_1G","overlayLogo":"spinner_overlayLogo__1NFEu"};